<div id="videos-offline">
  <header class="videos-offline-header">
    <h1>{{ 'offline.downloaded_materials' | translate }}</h1>
  </header>

  <main class="videos-offline-container">
    @if (videos$ | async; as videos) {
      <div class="videos-offline-container__grid">
        @if (videos.length > 0) {
          @for (video of videos; track video) {
            <div>
              <ng-template
                *ngTemplateOutlet="videoCard; context: { $implicit: video }"
              ></ng-template>
            </div>
          }
        } @else {
          <span class="without-items">{{
            'offline.offline_videos_error' | translate
          }}</span>
        }
      </div>
    }
  </main>
</div>

<ng-template #videoCard let-video>
  <div class="video-card">
    <div
      class="video-card__body"
      role="button"
      [routerLink]="[video?.path]"
      [relativeTo]="activatedRoute"
    >
      <picture>
        <img
          [src]="
            video.capa?.formats?.thumbnail?.url ||
            'assets/images/placeholder.png'
          "
          [alt]="video.titulo"
        />
      </picture>
    </div>

    <footer class="video-card__footer">
      <strong>{{ video.titulo }}</strong>
      <div class="video-card__footer__rightSide">
        <small>1/1</small>
        <div class="video-card__footer__rightSide__downloaded">
          <svg-icon
            src="assets/icons/download.svg"
            [svgStyle]="{
              'width.px': 12,
              'height.px': 14,
              fill: '#fff'
            }"
          ></svg-icon>
        </div>
      </div>
    </footer>
  </div>
</ng-template>
